<template>
  <BaseFormInput v-if="show" @keydown.enter.prevent="addPipelineStage" />
  <BaseButton
    v-else
    type="button"
    small
    primary
    class="flex items-center space-x-1"
    @click="setShow(true)"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-4 h-4 inline-flex"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="currentColor"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
    <span>Add stage</span>
  </BaseButton>
</template>

<script>
function data() {
  return {
    show: false,
  };
}

const methods = {
  setShow(value) {
    this.show = Boolean(value);
  },
  addPipelineStage(event) {
    if (event.target.value) {
      this.$emit('add-pipeline-stage', event.target.value);
    }

    this.setShow(false);
  },
};

export default {
  data,
  methods,
};
</script>
